import React from 'react'
import { ScrollControls, Scroll } from "@react-three/drei"
import { HiddenText, CascadeText, Rig } from '../helpers'

export function About(props) {
  return (
    <ScrollControls
      pages={2}
      damping={8}
    >
      <Rig />
      <Scroll html className="about">
        <div className='about-header' >
          <HiddenText show>{`ALIMOWSKI`}</HiddenText>
        </div>
        <div className="about-text" style={{margin: '100vh 0 1em 5vw'}}>
          {`${new Date().getFullYear()-2000-(new Date().getMonth() < 8)}yo aspiring creative developer, currently studying cs at wut. interested in web / interactive / motion design and `}
          <a target="_blank" rel="noreferrer"  href="https://mattersofthepen.tumblr.com/">
            <CascadeText nohover nofade style={{padding: 0}}>digital art</CascadeText>
          </a>
          .
        </div>
        <a target="_blank" rel="noreferrer"  href="mailto:dawid.alimowski@gmail.com"  className="about-text" style={{fontSize: '4vmax', width: 'fit-content', display: 'block', margin: '0 0 0 5vw'}}>
          <CascadeText nohover nofade style={{padding: 0}}>email</CascadeText>
        </a>
        <a target="_blank" rel="noreferrer"  href="https://github.com/dvalim" className="about-text" style={{fontSize: '4vmax', width: 'fit-content', margin: '0 0 0 5vw'}}>
          <CascadeText nohover nofade invert style={{padding: 0}}>github</CascadeText>
        </a>
      </Scroll>
    </ScrollControls>
  )
}